/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatGalleryResponse } from '../models/ChatGalleryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatGalleryRestControllerService {
    /**
     * @returns ChatGalleryResponse OK
     * @throws ApiError
     */
    public static getGallery({
        creatorId,
        fanId,
        lastId,
        mapCdnUrls = false,
        type = 'all',
    }: {
        creatorId: number,
        fanId: number,
        lastId?: number,
        mapCdnUrls?: boolean,
        type?: string,
    }): CancelablePromise<ChatGalleryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-gallery/{creatorId}/{fanId}',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
            query: {
                'lastId': lastId,
                'mapCdnUrls': mapCdnUrls,
                'type': type,
            },
        });
    }
}
